module.exports = __webpack_public_path__ + "static/img/20260905-03.1c6b35c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/20260905-03.webp
// module id = 9g6k
// module chunks = 1